
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form7";
const form7State = namespace("Form7");

@Component
export default class Rule57ApplicationInstructions extends Vue {   

    @form7State.Action
    public UpdateCurrentNoticeOfUrgentApplicationId!: (newCurrentNoticeOfUrgentApplicationId: string) => void

    public startNewForm7Document(){
        this.UpdateCurrentNoticeOfUrgentApplicationId(null);
        this.$router.push({name: "start-form7" })
    }

}

